import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledLoginErrorMessage = styled(Flexbox)(
    ({theme: {palette, spacing, shadows}}) => css`
        position: absolute;
        top: 100%;
        padding: ${spacing * 3}px;
        box-shadow: ${shadows.md};
        border: 1px solid ${palette.neutral['200']};
        border-radius: 8px;
        margin-top: 40px;
    `
)

export const StyledLoginErrorMessageTitle = styled.p(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};
        font-weight: 500;
        color: ${palette.neutral[950]};
    `
)

export const StyledLoginErrorMessageParagraph = styled.p(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[500]};
    `
)
